var industryInfo={
    classList:[
        {
            'name':"机器视觉系统",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/dianzi/%E5%8D%8A%E5%AF%BC%E4%BD%93%E8%8A%AF%E7%89%87%E6%91%86%E7%9B%98.mp4",
                    'title':"视觉引导半导体芯片摆盘",
                    'lable':"半导体芯片经传送带输送至工业相机下方，通过视觉系统定位、识别、检测来料并由机械手定点跟踪抓取、摆入料仓中，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度70次/min"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5mm"
                        },
                        {
                            'icon':"/static/case/xj.png",
                            'title':"利用高分辨率相机"
                        }
                        
                    ]
                }
            ]
        },
        {
            'name':"并联机器人",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/dianzi/%E5%8D%8A%E5%AF%BC%E4%BD%93%E8%8A%AF%E7%89%87%E6%91%86%E7%9B%98.mp4",
                    'title':"半导体芯片摆盘",
                    'lable':"半导体芯片经传送带输送至工业相机下方，通过视觉系统定位、识别、检测来料并由机械手定点跟踪抓取、摆入料仓中，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度70次/min/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5mm"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升50%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期18个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"芯片来料"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"视觉检测定位"
                        },{
                            'icon':"/static/case/fj.png",
                            'title':"机器人随动抓取"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"按程序放入物料盘"
                        },
                    ]
                },
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/dianzi/AOI%E4%B8%8A%E4%B8%8B%E6%96%99%E6%A3%80%E6%B5%8B%20.mp4",
                    'title':"AOI上下料检测",
                    'lable':"来料经传送带输送至工业相机下方，通过传感器识别、检测来料并提供OK/ NG指令及定点位置给到机器人，再由机器人进行高速追踪，抓取OK物料放置指定位置，同时剔除不合格物料至固定位置，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度70次/min/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5mm"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升50%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期12个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"物料来料"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"视觉检测定位"
                        },{
                            'icon':"/static/case/fz.png",
                            'title':"NG产品机器人放入NG位"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"OK产品机器人放入OK位"
                        },
                    ]
                },
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/dianzi/%E6%89%8B%E6%9C%BA%E4%B8%AD%E6%9D%BF%E5%85%A5%E7%AF%AE.mp4",
                    'title':"手机中板入篮",
                    'lable':"由机械手冲压机冲切之后的手机中板经传送带输送至工业相机下方，通过视觉系统定位、识别、检测来料并由机械手定点跟踪抓取、旋转90度之后插入清洗花篮中，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度70次/min/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±1mm"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工4人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期11个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"冲压件冲压来料"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"视觉检测定位"
                        },{
                            'icon':"/static/case/fj.png",
                            'title':"机器人随动抓取"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"翻转竖立放清洗花篮"
                        },
                    ]
                },
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/dianzi/%E7%94%B5%E7%A3%81%E7%82%89%E5%8F%91%E7%83%AD%E5%99%A8%E4%BB%B6%E8%A3%85%E9%85%8D%20.mp4",
                    'title':"电磁炉发热器件装配",
                    'lable':"电磁炉发热器件经传送带输送至工业相机下方，通过视觉系统定位、识别、检测来料并由机械手定点跟踪、抓取、放至固定位置，实现发热器件与电器底板高精度贴合，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度70片/min/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.2mm"
                        },
                        {
                            'icon':"/static/case/xzjd.png",
                            'title':"角度±0.5"
                        }
                        ,
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期18个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"底盘输送"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"视觉定位"
                        },{
                            'icon':"/static/case/cgqjc.png",
                            'title':"传感器检测散热片"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"机器人吸取散热片准确放置到位置"
                        },
                        {
                            'icon':"/static/case/cl.png",
                            'title':"满底盘流走"
                        },
                    ]
                },
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/dianzi/PCB%E6%9D%BF%E6%94%B6%E6%9D%BF%E5%8F%A0%E7%89%87%E5%B7%A5%E4%BD%9C%E7%AB%99%20.mp4",
                    'title':"PCB板收板叠片工作站",
                    'lable':"PCB板入清洗机后由输送带传送至工业相机下方，通过视觉系统定位、识别、检测，再由机器人进行高速追踪抓取，收板叠片，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度140片/min/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5mm"
                        },
                        {
                            'icon':"/static/case/xzjd.png",
                            'title':"旋转角度±0.05°"
                        }
                        ,
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期20个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/cl.png",
                            'title':"清洗机出料"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"视觉检测定位"
                        },{
                            'icon':"/static/case/fj.png",
                            'title':"机器人随动抓取"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"双工位叠片放置"
                        },
                    ]
                }
                ,
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/dianzi/PCB%E6%9D%BF%E5%85%A5%E6%B8%85%E6%B4%97%E6%9C%BA%E5%B7%A5%E4%BD%9C%E7%AB%99.mp4",
                    'title':"PCB板入清洗机工作站",
                    'lable':"PCB板经输送带传送至工业相机下方，通过视觉系统定位、识别、检测，再由机器人进行高速追踪抓取，收板入清洗机，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度70片/min/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5mm"
                        },
                        {
                            'icon':"/static/case/xzjd.png",
                            'title':"旋转角度±0.05°"
                        }
                        ,
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期24个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/cl.png",
                            'title':"分板机出料"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"视觉检测定位"
                        },{
                            'icon':"/static/case/fj.png",
                            'title':"机器人随动抓取"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"按规定程序规律放在皮带上"
                        },
                    ]
                }
            ]
        }
    ],
    name:"电子",
    title:"solutions",
    subtitle:"电子行业应用案例",
    subinfo:"我们的应用案例包括物料搬运、视觉快速分拣、通信元器件激光焊接、上下料服务等，可帮助您降本增效。",
}

export default {
    industryInfo
  };


// WEBPACK FOOTER //
// ./src/data/industryInfo/9.js